import { isElectron } from './miscUtils';

type LogMeta = Record<string, unknown>;

const SENSITIVE_KEY_PATTERN = /token|jwt|password|secret|authorization|auth/i;
const MAX_STRING_LENGTH = 500;

const sanitizeValue = (value: unknown): unknown => {
  if (value instanceof Error) {
    return {
      name: value.name,
      message: value.message,
    };
  }

  if (Array.isArray(value)) {
    return value.map(sanitizeValue);
  }

  if (value && typeof value === 'object') {
    const output: LogMeta = {};
    Object.entries(value as LogMeta).forEach(([key, childValue]) => {
      output[key] = SENSITIVE_KEY_PATTERN.test(key) ? '[redacted]' : sanitizeValue(childValue);
    });
    return output;
  }

  if (typeof value === 'string' && value.length > MAX_STRING_LENGTH) {
    return `${value.slice(0, MAX_STRING_LENGTH)}...`;
  }

  return value;
};

export const logDesktopAuthEvent = async (event: string, meta: LogMeta = {}): Promise<void> => {
  try {
    if (!isElectron() || typeof window === 'undefined') return;
    const desktopLog = (window as any).electron?.desktopLog;
    if (typeof desktopLog !== 'function') return;

    await desktopLog({
      scope: 'auth',
      event,
      meta: sanitizeValue(meta),
    });
  } catch {
    // Best-effort diagnostics only.
  }
};
